<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem>标签管理</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <Form ref="form" :model="formItem" :style="{'margin-bottom': '20px'}">
                <Row>
                    <Col span="8">
                        <span :style="{width: '25%', display: 'inline-block', 'margin-left': '20px'}">关键词:</span>
                        <Input v-model="formItem.keyword" :style="{width: '60%'}"></Input>
                    </Col>
                    <Col span="8">
                        <Button @click="getData(1,20,formItem.keyword)" style="margin-left:20px" type="primary">搜索</Button>
                    </Col>
                </Row>
            </Form>
            <Button @click="handleCreate()" style="margin:0px 10px 20px" type="primary">新增</Button>
            <Table :columns="columns" :data="data"></Table>
            <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
        </Card>
    </div>
</template>
<script>
import{labelList,deleteLabel}from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'labelAdmin',
    meta:{
        keepAlive: true // 开启缓存
    },
    data() {
        return {
            apps: [],
            formItem:{
                keyword: ''
            },
            columns: [
                {
                    title: "规则ID",
                    key: "custom_rule_id",
                    align: "center"
                },
                {
                    title: "规则名称",
                    key: "name",
                    align: "center"
                },
                {
                    title: "规则类型",
                    key: "condition_type",
                    align: "center",
                    render: (h, { row } ) => {
                        if (row.condition_type === 1) {
                            return h('span', {
                            }, '包含');
                        } else if (row.condition_type === 2) {
                            return h('span', {
                            }, '不包含');
                        }else if (row.condition_type === 3) {
                            return h('span', {
                            }, '小于');
                        }else if (row.condition_type === 4) {
                            return h('span', {
                            }, '小于等于');
                        }else if (row.condition_type === 5) {
                            return h('span', {
                            }, '等于');
                        }else if (row.condition_type === 6) {
                            return h('span', {
                            }, '大于等于');
                        }else if (row.condition_type === 7) {
                            return h('span', {
                            }, '大于');
                        }
                    }
                },
                {
                    title: "比较值",
                    key: "condition_value",
                    align: "center"
                },
                {
                    title: "用户标签",
                    key: "key",
                    align: "center"
                },
                {
                    title: "是否激活",
                    key: "active_flag",
                    align: "center",
                    render: (h, { row } ) => {
                        if (row.active_flag === 1) {
                            return h('span', {
                            }, '是');
                        } else if (row.active_flag === 0) {
                            return h('span', {
                            }, '否');
                        }
                    }
                },
                {
                    title: "操作",
                    key: "action",
                    align: "center",
                    width: '200',
                    render: (h, params) => {
                        return h("div", [
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: "editLabel",
                                            query: {
                                                custom_rule_id: params.row.custom_rule_id,
                                            },
                                        });
                                    },
                                },
                            },"编辑"),
                            h("Button",{
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                    this.$Modal.confirm({
                                        title: "提示",
                                        content: "是否删除该项？",
                                        onOk: () => {
                                            this.remove(params.index)
                                        },
                                    });
                                    },
                                },
                            },"删除"),
                        ]);
                    },
                },
            ],
            data:[],
            total_count:0,
            page:1
        };
    },
    methods: {
        getData(page=1,page_size=20,keyword=''){
            labelList({page,page_size,keyword}).then(res=>{
                if(res.data.code==200){
                    this.data=res.data.data.rules
                    this.total_count=res.data.data.total
                    this.page = page
                }
            })
        },
        changePage(page){
            this.getData(page,20,this.formItem.keyword);
        },
        handleCreate(){
            this.$router.push({
                name: "createLabel",
            });
        },
        remove (index) {
            deleteLabel(
                {
                    custom_rule_ids: this.data[index].custom_rule_id
                }
            ).then(({ data: res }) => {
                if (res.code === 200){
                    this.getData(this.page,20,this.formItem.keyword)
                }
                this.$Message.info(res.msg);
            })
        }
    },
    created() {
        Cookies.set('active_name', '6');
        this.getData(1,20,'')
    },
    activated() {
        // 在这里刷新列表
        this.getData(this.page,20,this.formItem.keyword)
    },
};
</script>


// WEBPACK FOOTER //
// src/views/Label/LabelList.vue